export function getDefaultImage(role) {
    if (role === 'item') {
        return 'https://dl.negahgroup.ir/app-files/instacatalog/images/static-image/no-image.png'
    } else {
        return 'https://dl.negahgroup.ir/app-files/instacatalog/images/static-image/no-profile-image.png'
    }
}